import React, { useCallback } from 'react';
import Button from '../../../../components/Button/Button';
import { PortalWithState } from 'react-portal';
import ApproveTestReportsModal from './ApproveTestReportsModal';
import { getToken } from '../../../../services/auth';
import { IdArrayInput } from '../../../../hooks/useTablePages';
import RequirePerms from '@/components/RequirePerms';

type TestReportsActionsProps = { jobIds: IdArrayInput };

const TestReportsActions: React.FC<TestReportsActionsProps> = ({
  jobIds,
}): JSX.Element => {
  const downloadTestReportPdfs = useCallback(() => {
    if (!jobIds || jobIds.length === 0) {
      return;
    }
    const jobIdsPart = `jobIds=${jobIds.join(',')}`;

    const url = `${
      import.meta.env.ECOS_API_BASE
    }/test-reports/?${jobIdsPart}&token=${getToken()}`;
    window.open(url);
  }, [getToken, jobIds]);

  return (
    <>
      <RequirePerms backflowTests="UPDATE">
        <PortalWithState closeOnOutsideClick closeOnEsc>
          {({ openPortal, closePortal, portal }) => (
            <>
              <Button
                variant="outline"
                disabled={!jobIds.length}
                icon="check-circle"
                onClick={openPortal}
              >
                Approve
              </Button>
              {portal(
                <ApproveTestReportsModal
                  action="APPROVE"
                  jobIds={jobIds}
                  onClose={closePortal}
                />
              )}
            </>
          )}
        </PortalWithState>
      </RequirePerms>
      <RequirePerms backflowTests="UPDATE">
        <PortalWithState closeOnOutsideClick closeOnEsc>
          {({ openPortal, closePortal, portal }) => (
            <>
              <Button
                variant="outline"
                disabled={!jobIds.length}
                icon="slash-circle"
                onClick={openPortal}
              >
                Reject
              </Button>
              {portal(
                <ApproveTestReportsModal
                  action="REJECT"
                  jobIds={jobIds}
                  onClose={closePortal}
                />
              )}
            </>
          )}
        </PortalWithState>
      </RequirePerms>
      <RequirePerms backflowTests="READ">
        <Button
          variant="outline"
          disabled={!jobIds.length}
          icon="file-download"
          onClick={downloadTestReportPdfs}
        >
          Test Report{jobIds.length > 1 ? 's' : ''}
        </Button>
      </RequirePerms>
    </>
  );
};

export default TestReportsActions;
